<!--  -->
<template>
	<div class="page">
		<div class="set-early flex" @click="yjShow = true">
			<div class="set-early1 flex">
				<div class="set-early2"></div>
				<div style="
            margin-top: 7px;
            margin-left: 6px;
            color: #fff;
            font-weight: 500;
            font-size: 16px;
          ">
					设置预警值
				</div>
			</div>
		</div>

		<el-popover placement="left" width="400" trigger="click" popper-class="popoverclass" style="">
			目前土壤水分含量低于标准10%左右，每亩浇水量建议5-10吨（根据土壤和灌溉方式调整），分次灌溉更高效，同时结合玉米生长阶段和天气灵活管理。高温时段避免中午浇水，建议清晨或傍晚进行。
			<div slot="reference" class="fenxi">
				<div class="tex">分析报告</div>
			</div>
		</el-popover>

		<div class="flex">
			<div class="qx" style="margin-top: 140px; margin-left: 30px">
				<div class="fout-emotions-title">气象</div>
				<div class="content flex">
					<div class="flexCol alit">
						<div class="flex alit justb" v-if="real">
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%B0%94%E8%B1%A1%402x%20%282%29.png"
								style="width: 125px; height: 108px" alt="" />
							<div class="tq">多云转晴 <a>{{real.temp}}</a>℃</div>
							<div class="ssqh">实时气候</div>
						</div>
						<div class="qx-data flex" style="flex-wrap: wrap">
							<div class="" style="width: 33%">空气质量:44ug</div>
							<div class="" style="width: 33%">等级:2级</div>
							<div class="" style="width: 33%">描述:优良</div>
							<div class="" style="width: 33%">东南风 2级 6km/h</div>
							<div class="" style="width: 33%">湿度:39%</div>
							<div class="" style="width: 33%">能见度:10km</div>
							<div class="" style="width: 33%">气压:850pa</div>
						</div>
						<div class="flex justb">
							<div class="flex justb">
								<!-- <div class="" style="width: 22px;">历史湿度</div> -->
								<qxOne class="earhcts-wh"></qxOne>
								<qxTwo class="earhcts-wh"></qxTwo>
								<qxThree class="earhcts-wh"></qxThree>
							</div>
						</div>
					</div>
					<div class="">
						<div class="">
							<div class="flex alit" style="color: #ffffff; font-size: 16px">
								<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%AE%9E%E6%97%B6%E6%B0%94%E8%B1%A1%402x.png"
									style="width: 19px; height: 19px; margin-right: 10px" alt="" />
								实时气候
							</div>
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A8%AA%E7%BA%BF%402x.png"
								style="width: 163px; height: 4px; margin-top: 4px" alt="" />
						</div>
						<qxFour style="height: 45%;width: 90%;"></qxFour>

						<div class="">
							<div class="flex alit" style="color: #ffffff; font-size: 16px">
								<img src=" https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E9%A2%84%E8%AD%A6%E4%BF%A1%E6%81%AF%402x.png"
									style="width: 19px; height: 19px; margin-right: 10px" alt="" />
								预警信息
							</div>
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A8%AA%E7%BA%BF%402x.png"
								style="width: 163px; height: 4px; margin-top: 4px" alt="" />
						</div>
						<vue-seamless-scroll :data="yjData" class="warp" :class-option="classOption2">
							<ul class="item">
								<li v-for="(item, index) in yjData" :key="index"
									style="height: 40px; margin-left: -25px" :data="JSON.stringify(item)">
									<div class="yujing flex alit" style="margin-right: 5px;flex:1">
										<div class="yujing-type flex alit justc">
											<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E9%A2%84%E8%AD%A6%E6%B8%A9%E5%BA%A6%402x.png"
												alt="" />
											{{ item.type }}
										</div>
										<div class="" style="flex: 1;line-height: 17px;margin-right: 25px;">{{ item.content }}</div>
									</div>
								</li>
							</ul>
						</vue-seamless-scroll>
					</div>
				</div>
			</div>
			<div class="sq" style="margin-top: 140px; margin-left: 10px">
				<div class="fout-emotions-title"
					style="background-image:url(https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%9B%BE%E7%89%87_131_07.png)"
					@click="goPage('/trEmotions')">墒情</div>
				<div class="content flex">
					<div class="" style="margin-left: 20px">
						<!-- <div class="" style="margin: 15px 0">
							<div class="flex alit" style="color: #ffffff; font-size: 16px">
								张掖市1号墒情站
							</div>
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A8%AA%E7%BA%BF%402x.png"
								style="width: 163px; height: 4px; margin-top: 4px" alt="" />
						</div> -->
						<div class="sq-info">
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/cc579b77facb4e5580c4edf155b547ce_mergeImage.png"
								style="" class="sqimage" alt="" />
						<!-- 	<div class="flex justb">
								<div class="">土壤容重值:1.2g/cm³</div>
								<div class="">作物种植面积系数:0.5%</div>
							</div>
							<div class="flex justb">
								<div class="">田间最大持水量:30%</div>
								<div class="">灌溉深度:500mm</div>
							</div> -->
							<div class="flex justb">
								<div class="">位置:甘州区新墩镇双堡村</div>
							</div>
						</div>
					</div>
					<div class="" style="width: 100%">
						<div class="" style="margin-left: 20px; margin-top: 10px">
							<div class="flex alit" style="color: #ffffff; font-size: 16px">
								<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E6%A8%A1%E5%9E%8B%402x%20%281%29.png"
									style="width: 19px; height: 19px; margin-right: 10px" alt="" />
								墒情模型
							</div>
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A8%AA%E7%BA%BF%402x.png"
								style="width: 163px; height: 4px; margin-top: 4px" alt="" />
						</div>
						<sqOne style="width: 92%; height: 150px"></sqOne>
						<div class="" style="margin-left: 20px">
							<div class="flex alit" style="color: #ffffff; font-size: 16px">
								<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E5%AE%9E%E6%83%85%402x%20%281%29.png"
									style="width: 19px; height: 19px; margin-right: 10px" alt="" />
								墒情实情
							</div>
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A8%AA%E7%BA%BF%402x.png"
								style="width: 163px; height: 4px; margin-top: 4px" alt="" />
						</div>
						<sqTwo style="width: 92%; height: 150px"></sqTwo>
					</div>
				</div>
			</div>
		</div>
		<div class="flex" style="margin-top: 20px; margin-left: 30px">
			<div class="mq">
				<div class="fout-emotions-title"
					style="background-image:url(https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%9B%BE%E7%89%87_1.png)">
					苗情</div>
				<div class="content flexCol">
					<div class="flex alit justc" style="margin: 5px 0">
						<div class="mqjc">苗情监测</div>
						<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/%E8%8B%97%E6%83%85%E5%8F%B3%E7%AE%AD%E5%A4%B4.png"
							style="width: 119px; height: 38px;margin:0 20px;" alt="" />
						<div class="mqcj">苗情采集</div>
						<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/%E8%8B%97%E6%83%85%E5%8F%B3%E7%AE%AD%E5%A4%B4.png"
							style="width: 119px; height: 38px;margin:0 20px;" alt="" />
						<div class="mqzd">苗情指导</div>
					</div>
					<div class="flex alit justc">
						<div class="mqjj flex alit justc">
							<!-- <img src="https://ica.obs.cn-south-1.myhuaweicloud.com/1024x1024.png"
                                style="width: 90%;height:90%;" alt=""> -->
							<div class="mse" id="mse" style="width: 90%; height: 90%; border-radius: 10px"></div>
						</div>
						<div class="mqjj flexCol alit justc" style="margin: 0 5px">
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/748ba7ed584c43dab5f4e172b7ab7c6c.png"
								style="width: 90%; height: 40%" alt="" />
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/e891e869106e86c6b81418f603ee4030.png"
								style="width: 90%; height: 40%; margin-top: 3%" alt="" />
						</div>
						<div class="mqjj flexCol alit">
							<div class="mqjldown" style="">
								<div class="" style="">
									<div class="flex alit" style="color: #ffffff; font-size: 16px">
										<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%8B%97%E6%83%85%E7%BB%93%E8%AE%BA%402x.png"
											style="width: 19px; height: 19px; margin-right: 10px" alt="" />
										苗情结论
									</div>
									<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8C%87%E5%AF%BC%E6%84%8F%E8%A7%81%402x.png"
										style="width: 163px; height: 4px; margin-top: 4px" alt="" />
								</div>
							<!-- 	<div class="jl">
									该农田已通过直线划分为左右两个区域，左侧较宽且存在车辙压实痕迹，右侧较窄可能为作业通道。
								</div>
								<div class="" style="margin-top: 10px">
									<div class="flex alit" style="color: #ffffff; font-size: 16px">
										<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8C%87%E5%AF%BC%E6%84%8F%E8%A7%81%402x.png"
											style="width: 19px; height: 19px; margin-right: 10px" alt="" />
										指导意见
									</div>
									<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A8%AA%E7%BA%BF%402x.png"
										style="width: 163px; height: 4px; margin-top: 4px" alt="" />
								</div> -->
								<div class="jl">
									1、结合玉米播种前苗情处置需求，需优先对左侧主种植区开展精细化整地：清除地表杂草及作物残茬，采用旋耕机破碎土块并深翻20-30cm以打破犁底层；针对车辙造成的局部土壤板结区域，应使用圆盘耙进行交叉碎土，确保土壤容重降至1.3g/cm³以下。<br/>
									2、同时检测杆顶绿色装置（推测为土壤传感器）反馈数据，若监测到0-20cm土层含水量低于田间持水量65%，需启动播前滴灌润土；右侧狭窄区域可保留作为农机掉头缓冲带，但需同步清理散落秸秆防止萌发杂草。全田按"南-北"走向设置株行距，配合北斗导航精量播种机实现等行距密植，最终达成苗齐、苗匀、苗壮的农艺目标。
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cq" style="margin-left: 10px">
				<div class="fout-emotions-title"
					style="background-image:url(https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%9B%BE%E7%89%87_131_08.png)">
					虫情</div>
				<div class="content flex alit">
					<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%99%AB%E6%83%85%E6%B5%8B%E6%8A%A5%E4%BB%AA.png"
						style="width: 240px; height: 336px; margin: 0 10px" alt="" />
					<div class="" style="flex: 1; margin-right: 20px">
						<div class="flex justb" style="margin-right: 10px">
							<div class="flex alit cq-right-top-title">运行模式</div>
							<div class="flex justb" style="flex: 1">
								<div v-if="isManual" class="sd" @click="switchButton">手动</div>
								<div v-else class="zd" @click="switchButton">自动</div>
								<div class="paizhao flex alit justc">
									<img style="width: 21px; height: 17px; margin-right: 10px"
										src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E7%9B%B8%E6%9C%BA%402x.png"
										alt="" />
									拍照
								</div>
							</div>
						</div>

						<div class="flex justb" style="flex: 1; margin: 13px 10px 18px 0">
							<div class="flex alit">
								<div class="cq-right-top-title">诱虫灯</div>
								<el-switch v-model="value1" :width="47" active-color="#00B4FF" inactive-color="#FF755F">
								</el-switch>
							</div>
							<div class="flex alit">
								<div class="cq-right-top-title2">虫雨挡板</div>
								<el-switch v-model="value2" :width="47" active-color="#00B4FF" inactive-color="#FF755F">
								</el-switch>
							</div>
							<div class="flex alit">
								<div class="cq-right-top-title2">杀虫挡板</div>
								<el-switch v-model="value3" :width="47" active-color="#00B4FF" inactive-color="#FF755F">
								</el-switch>
							</div>
						</div>
						<div class="flex justb" style="flex: 1; margin-right: 10px">
							<div class="flex alit">
								<div class="cq-right-top-title">烘干挡板</div>
								<el-switch v-model="value4" :width="47" active-color="#4A2102" inactive-color="#FF755F">
								</el-switch>
							</div>
							<div class="flex alit">
								<div class="cq-right-top-title2">移虫装置</div>
								<el-switch v-model="value5" :width="47" active-color="#00B4FF" inactive-color="#FF755F">
								</el-switch>
							</div>
							<div class="flex alit">
								<div class="cq-right-top-title2">杀虫控制</div>
								<el-switch v-model="value6" :width="47" active-color="#00B4FF" inactive-color="#FF755F">
								</el-switch>
							</div>
						</div>

						<div class="" style="margin-top: 10px">
							<div class="flex alit" style="color: #ffffff; font-size: 16px">
								<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%99%BA%E8%83%BD%E5%88%86%E6%9E%90%402x.png"
									style="width: 19px; height: 19px; margin-right: 10px" alt="" />
								AI智能分析
							</div>
							<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A8%AA%E7%BA%BF%402x.png"
								style="width: 163px; height: 4px; margin-top: 4px" alt="" />
						</div>

						<div class="flex justb" style="margin: 11px 0 20px 0">
							<div class="flex alit">
								<div class="cjsj">采集时间</div>
								<div class="">
									<el-date-picker v-model="createTime" type="datetimerange" start-placeholder="开始日期"
										value-format="yyyy-MM-dd HH:mm:ss" end-placeholder="结束日期"
										:default-time="['12:00:00']">
									</el-date-picker>
								</div>
							</div>
							<div class="search flex alit justc" @click="getWormList()">
								<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%9F%A5%E8%AF%A2%402x.png"
									style="widows: 16px; height: 16px; margin-right: 9px" alt="" />
								查询
							</div>
						</div>

						<div class="aifx-title flex justb alit">
							<div class="" style="width: 25%">采样时间</div>
							<div class="" style="width: 25%">分析时间</div>
							<div class="" style="width: 15%">害虫数量</div>
							<div class="" style="width: 20%">害虫分析</div>
							<div class="" style="width: 15%">图片查看</div>
						</div>
						<vue-seamless-scroll :data="cqData" class="warp" :class-option="classOption3"
							style="height: 92px; overflow: hidden; margin-top: 10px">
							<ul class="item" style="list-style-type: none; padding: 0">
								<li v-for="(item, index) in cqData" :key="index"
									style="height: 36px; margin-bottom: 10px" :data="JSON.stringify(item)">
									<div class="ai-list flex alit" style="margin-right: 5px">
										<div class="" style="width: 25%">
											{{ utils.changeTime(item.verifyTime) }}
										</div>
										<div class="" style="width: 25%">
											{{ utils.changeTime(item.createTime) }}
										</div>
										<div class="" style="width: 15%">{{ item.analyseNum }}</div>
										<div class="textOne" style="width: 20%">
											{{ item.analyseContent }}
										</div>
										<div class="" style="width: 10%">
											<el-image style="
                          height: 35px;
                          margin-top: 5px;
                          object-fit: contain;
                        " :src="item.analyseCoordUrl" :preview-src-list="[item.analyseCoordUrl]">
											</el-image>
										</div>
									</div>
								</li>
							</ul>
						</vue-seamless-scroll>
					</div>
				</div>
			</div>
		</div>

		<div class="dialog flexCol alit justc" v-if="yjShow">
			<div class="mask" @click="yjShow = false"></div>
			<div class="cont" style="background-color: #071f39; width: 800px; height: 480px">
				<img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E5%85%B3%E9%97%AD%20%282%29.png"
					class="dialog-close" alt="" @click="yjShow = false" />
				<div class="cq" style="margin-top: 5px">
					<div class="fout-emotions-title">预警值设置</div>
				</div>
				<div class="flexCol alit">
					<div>
						<div class="flex alit info">
							温度高于
							<div class="input-style">
								<el-input v-model="yjSetData.wdTop"></el-input>
							</div>
							℃连续
							<div class="input-style">
								<el-input v-model="yjSetData.wdTopDay"></el-input>
							</div>
							天
						</div>
						<div class="flex alit info">
							温度低于
							<div class="input-style">
								<el-input v-model="yjSetData.wdDown"></el-input>
							</div>
							℃
						</div>
						<div class="flex alit info">
							风力超过
							<div class="input-style">
								<el-input v-model="yjSetData.fl"></el-input>
							</div>
							级
						</div>

						<div class="flex alit info">
							空气相对湿度低于
							<div class="input-style">
								<el-input v-model="yjSetData.kqsd"></el-input>
							</div>
							% 预警
						</div>
						<div class="flex alit info">
							田间土壤含水量低于
							<div class="input-style">
								<el-input v-model="yjSetData.trhsl"></el-input>
							</div>
							% 预警
						</div>
						<el-button type="primary" class="submit" @click="yjShow = false">确认修改</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qxOne from "./qxOne.vue";
	import qxTwo from "./qxTwo.vue";
	import qxThree from "./qxThree.vue";
	import qxFour from "./qxFour.vue";
	import sqOne from "./sqOne.vue";
	import sqTwo from "./sqTwo.vue";
	import vueSeamlessScroll from "vue-seamless-scroll";

	import Player from "xgplayer";
	import FlvPlugin from "xgplayer-flv";
	import "xgplayer/dist/index.min.css";
	export default {
		components: {
			qxOne,
			qxTwo,
			qxThree,
			vueSeamlessScroll,
			qxFour,
			sqOne,
			sqTwo,
		},
		data() {
			return {
				yjSetData: {
					wdTop: "",
					wdTopDay: "",
					wdDown: "",
					fl: "",
					kqsd: "",
					trhsl: "",
				},
				cqData: [],
				yjData: [{
						type: "低温",
						content: "低温持续，夜间易出现霜冻。",
					},
					{
						type: "大风",
						content: "多大风天气，注意防风固土。",
					},
					{
						type: "土壤",
						content: "土壤偏干，及时补水保墒备播种。",
					},
					// {
					// 	type: "空气",
					// 	content: "重污染天气，暂停叶面肥，增施抗逆剂。",
					// },
					{
						type: "降水",
						content: "降水补墒，低洼防积水，提前清渠追肥。",
					},
					// {
					// 	type: "苗情",
					// 	content: "高湿环境易诱发霜霉及茎腐病，需重点检查叶片!",
					// },
				],
				classOption2: {
					singleHeight: 42,
					limitMoveNum: 4,
					hoverStop: true,
					waitTime: 3000,
				},
				classOption3: {
					singleHeight: 46,
					limitMoveNum: 4,
					hoverStop: true,
					waitTime: 3000,
				},
				value1: false,
				value2: false,
				value3: false,
				value4: false,
				value5: false,
				value6: false,
				isManual: true,
				createTime: null,
				yjShow: false,
				real: null
			};
		},
		// 监听属性 类似于data概念
		computed: {},
		// 监控data中的数据变化
		watch: {},
		// 方法集合
		methods: {
			getReal() {
				this.$request(`iot/screen/weather/getReal?id=1`).then(
					(res) => {
						console.log(res);
						this.real = res.data;
					}
				);
			},
			goPage(url) {
				console.log(url);
				this.$router.push(url)
			},
			openSetYj() {},
			switchButton() {
				this.isManual = !this.isManual; // 切换状态
			},
			getWormList() {
				console.log(this.createTime);
				let startTime = "";
				let endTime = "";
				if (this.createTime) {
					startTime = this.createTime[0];
					endTime = this.createTime[1];
				}
				this.$request(
					"iot/worm/list?deviceNo=111&startTime=" +
					startTime +
					"&endTime=" +
					endTime
				).then((res) => {
					this.cqData = res.data;
				});
			},
		},
		// 生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.getWormList();
			this.getReal()
		},
		// 生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
			const config = {
				id: "mse",
				url: "https://cmgw-vpc.lechange.com:8890/flv/LCO/BE049D6PAJ0965A/0/1/20250703104157/openhzaa579a430b42418baa59fa33c5f1ca62.flv?proto=https&source=open",
				playsinline: true,
				plugins: [],
				videoInit: true,
				ignores: ["fullscreen"],
				width: "90%",
				height: "90%",
				cssFullscreen: true,
			};
			config.plugins.push(FlvPlugin);
			let player = new Player(config);
		},
		beforeCreate() {}, // 生命周期 - 创建之前
		beforeMount() {}, // 生命周期 - 挂载之前
		beforeUpdate() {}, // 生命周期 - 更新之前
		updated() {}, // 生命周期 - 更新之后
		beforeDestroy() {}, // 生命周期 - 销毁之前
		destroyed() {}, // 生命周期 - 销毁完成
		activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style lang='scss' scoped>
	.sqimage {
		width: 407px;
		/* height: 19vh; */
		height: 300px;
		margin-top: 20px;
	}

	.earhcts-wh {
		height: 155px !important;
		width: 165px !important;
	}

	.fenxi {
		width: 45px;
		height: 107px;
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%88%86%E6%9E%90%E6%8A%A5%E5%91%8A%402x.png");
		background-size: 100% 100%;
		position: fixed;
		right: 20px;
		top: 340px;
		cursor: pointer;

		.tex {
			width: 21px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 12px;
			color: #ffffff;
			text-align: right;
			margin-left: 15px;
			margin-top: 18px;
		}
	}

	.submit {
		width: 60%;
		margin-top: 40px;
		margin-left: 30px;
		background: #001736;
	}

	.input-style {
		margin: 0 5px 0 10px;

		.el-input {
			width: 81px;
			height: 32px;
		}

		::v-deep .el-input__inner {
			background: linear-gradient(180deg,
					rgba(0, 87, 202, 0.3) 0%,
					rgba(0, 23, 54, 0.64) 100%) !important;
			border-radius: 6px;
			border: 1px solid #2e5c94;
			text-align: center;
			color: #fff;
		}
	}

	.info {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		margin-top: 30px;
	}

	.dialog {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999999;

		.dialog-close {
			width: 30px;
			height: 30px;
			position: absolute;
			right: 20px;
			top: 10px;
			z-index: 99;
			cursor: pointer;
		}

		.table-name {
			font-size: 20px;
		}

		.table-search {
			font-size: 15px;
		}

		/* 移除所有内部边框 */
		.outer-border-table>>>.el-table__body tr td,
		.outer-border-table>>>.el-table__body tr th,
		.outer-border-table>>>.el-table__header-wrapper tr th {
			border: none !important;
		}

		/* 添加外边框 */
		.outer-border-table {
			border: 1px solid #ebeef5;
			border-radius: 4px;
		}

		/* 移除默认的表格边框 */
		.outer-border-table>>>.el-table__header,
		.outer-border-table>>>.el-table__body,
		.outer-border-table>>>.el-table__footer {
			border: none !important;
		}

		.search {
			height: 31px;
			line-height: 31px;
			background: #366ec0;
			border-radius: 4px;
			text-align: center;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
			margin-right: 10px;
			padding: 0 10px;
			cursor: pointer;
		}

		.search2 {
			height: 31px;
			background: #366ec0;
			border-radius: 4px;
			text-align: center;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
			margin-right: 10px;
			padding: 0 10px;
			cursor: pointer;
		}

		.mask {
			width: 100vw;
			height: 100vh;
			z-index: 1500;
			background-color: rgba(0, 0, 0, 0.3);
			position: absolute;
		}

		.cont {
			position: relative;
			z-index: 99999999999;
			background-color: #fff;
			border-radius: 20px;
		}
	}

	.set-early {
		position: fixed;
		right: 30px;
		top: 90px;
		cursor: pointer;
		z-index: 999;

		.set-early1 {
			width: 132px;
			height: 36px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/button%402x.png");
			background-size: 100% 100%;

			.set-early2 {
				width: 20px;
				height: 17px;
				background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E7%BC%96%E7%BB%84%402x.png");
				background-size: 100% 100%;

				margin-top: 10px;
				margin-left: 13px;
			}
		}
	}

	.cq {
		.sd {
			width: 90px;
			height: 30px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%89%8B%E5%8A%A8%402x%20%282%29.png");
			background-size: 100% 100%;

			font-weight: 500;
			font-size: 14px;
			color: #fff;
			line-height: 30px;
			text-align: center;
		}

		.zd {
			width: 90px;
			height: 30px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%87%AA%E5%8A%A8%402x%20%281%29.png");
			background-size: 100% 100%;

			font-weight: 500;
			font-size: 14px;
			color: #fff;
			line-height: 30px;
			text-align: center;
		}

		/* 修改选中时的背景色 */
		::v-deep .el-switch.is-checked .el-switch__core {
			background-color: rgba(0, 180, 255, 0.4) !important;
			border-color: #00b4ff !important;
		}

		/* 修改未选中时的背景色 */
		::v-deep .el-switch__core {
			background-color: #a19f9f !important;
			border-color: #a19f9f !important;
		}

		.ai-list {
			width: 620px;
			height: 36px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E4%BF%A1%E6%81%AF%E6%A0%8F%402x.png");
			background-size: 100% 100%;

			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			text-align: center;
		}

		.aifx-title {
			width: 620px;
			height: 36px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E6%A0%87%E9%A2%98%E6%A0%8F%402x.png");
			background-size: 100% 100%;

			font-weight: 500;
			font-size: 14px;
			color: #00ffd1;
			text-align: center;
		}

		.el-input__inner {
			background: linear-gradient(180deg,
					rgba(0, 87, 202, 0.3) 0%,
					rgba(0, 23, 54, 0.64) 100%) !important;
			border-radius: 2px !important;
			border: 1px solid !important;
			border-image: linear-gradient(124deg,
					rgba(156, 211, 225, 0),
					rgba(194, 243, 255, 1),
					rgba(156, 211, 225, 0)) 1 1 !important;
		}

		::v-deep .el-range-input {
			background: rgba(156, 211, 225, 0) !important;
			cursor: pointer;
		}

		::v-deep .el-range-separator {
			color: #fff !important;
		}

		.cjsj {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 10px;
		}

		.search {
			width: 73px;
			height: 31px;
			background: #366ec0;
			border-radius: 2px;

			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
		}

		.cq-right-top-title2 {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 2px;
			width: 60px;
		}

		.cq-right-top-title {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 12px;
			width: 60px;
		}
	}

	.paizhao {
		width: 88px;
		height: 30px;
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E8%83%8C%E6%99%AF%402x.png");
		background-size: 100% 100%;

		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
	}

	.mq {
		.mqjldown {
			height: 225px;
			width: 270px;
			overflow-y: auto;
			margin-left: 10px;
			margin-top: 10px;
		}

		/* 设置滚动条整体样式 */
		.mqjldown::-webkit-scrollbar {
			width: 8px;
			/* 垂直滚动条宽度 */
			height: 8px;
			/* 水平滚动条高度 */
		}

		/* 设置滚动条轨道 */
		.mqjldown::-webkit-scrollbar-track {
			background: rgba(202, 199, 199, 0.1);
			/* 轨道背景色 */
			border-radius: 4px;
			/* 圆角 */
		}

		/* 设置滚动条滑块 */
		.mqjldown::-webkit-scrollbar-thumb {
			background: #5d70db;
			/* 滑块颜色 */
			border-radius: 4px;
			/* 圆角 */
		}

		/* 设置鼠标悬停在滑块上的样式 */
		.mqjldown::-webkit-scrollbar-thumb:hover {
			background: #5166db;
			cursor: pointer;
			/* 悬停时颜色 */
		}

		.mqjj {
			width: 284px;
			height: 241px;

			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%8B%97%E6%83%85%E7%AE%80%E4%BB%8B%E8%83%8C%E6%99%AF%402x.png");
			background-size: 100% 100%;

			.jl {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #ffffff;
				line-height: 26px;
			}
		}

		.mqjc {
			width: 140px;
			height: 120px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/00c.png");
			background-size: 100% 100%;
			text-align: center;
			line-height: 130px;

			font-weight: 500;
			font-size: 13px;
			color: #ffffff;
		}

		.mqcj {
			width: 140px;
			height: 120px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/00c.png");
			background-size: 100% 100%;
			text-align: center;
			line-height: 130px;

			font-weight: 500;
			font-size: 13px;
			color: #ffffff;
		}

		.mqzd {
			width: 140px;
			height: 120px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/00c.png");
			background-size: 100% 100%;
			text-align: center;
			line-height: 130px;

			font-weight: 500;
			font-size: 13px;
			color: #ffffff;
		}
	}

	.sq {
		.sq-info {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			line-height: 30px;
		}

		position: relative;
		z-index: 9999;
	}

	.qx {
		.warp {
			height: 32%;
			width: 100%;
			overflow: hidden;
			background: rgba(255, 255, 255, 0.03);
			display: block;

			.yujing {
				width: 110%;
				height: 30px;
				background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E9%A2%84%E8%AD%A6%E8%83%8C%E6%99%AF%402x.png");
				background-size: 100% 100%;
				font-weight: 400;
				font-size: 14px;
				color: #ffffff;
				/* line-height: 30px; */

				// background: red;
				.yujing-type {
					width: 63px;
					height: 22px;
					background: linear-gradient(270deg,
							rgba(43, 85, 145, 0.5) 0%,
							rgba(30, 83, 133, 0.5) 100%);
					border-radius: 28px;
					border: 1px solid #0083ff;
					font-weight: 400;
					font-size: 12px;
					color: #ffffff;
					margin: 0 10px;

					img {
						width: 12px;
						height: 12px;
						margin-right: 4px;
					}
				}
			}

			.item {
				padding: 0;
			}

			ul {
				list-style: none;
				padding: 10px 0;
				margin: 0;
				width: 100%;
				// background-color: rgba(255, 255, 255, 0.1);

				li {
					padding: 0 5% 0 5%;
					height: 50px;
					line-height: 50px;
				}

				li:hover {
					background-color: #01a8ff;
				}
			}
		}

		.history {
			// width: 71px;
			// height: 71px;
			// background-image: url('https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%8E%86%E5%8F%B2%E6%95%B0%E6%8D%AE%E8%83%8C%E6%99%AF%402x.png');
			// background-size: 100% 100%;
			// width: 200px;
			// text-align: center;

			// font-weight: 400;
			// font-size: 10px;
			// color: #FFFFFF;
		}

		.qx-data {
			width: 380px;
			height: 105px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%B0%94%E8%B1%A1%E6%95%B0%E6%8D%AE%402x.png");
			background-size: 100% 100%;

			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			line-height: 30px;
		}

		.ssqh {
			width: 118px;
			height: 34px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%AE%9E%E6%97%B6%E6%B0%94%E5%80%99%402x.png");
			background-size: 100% 100%;

			font-weight: 400;
			font-size: 16px;
			color: #ffffff;
			line-height: 34px;
			padding-left: 10px;
		}

		.tq {
			font-weight: 400;
			font-size: 16px;
			color: #ffffff;
			margin: 0 22px 0 10px;
		}
	}

	.content {
		width: 870px;
		height: 373px;
		background: linear-gradient(180deg,
				rgba(55, 157, 230, 0.1) 0%,
				rgba(25, 100, 200, 0.1) 100%);
	}

	.fout-emotions-title {
		width: 835px;
		height: 38px;
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A0%87%E9%A2%98%402x%20%281%29.png");
		background-size: 100% 100%;
		font-family: YouSheBiaoTiHei;
		font-size: 20px;
		color: #c4dcf0;
		line-height: 38px;
		padding-left: 30px;
	}

	.page {
		width: 100vw;
		height: 100vh;
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%9B%9B%E6%83%85%E8%83%8C%E6%99%AF%402x.png");
		background-size: 100% 100%;
		overflow: hidden;
	}
</style>